<template>
	<div class="content">
		<div class="container-fluid">
			<div class="row">
				<div class="col-md-12">
					<div class="card">
					<div class="card-header card-header-info">
						<h4 class="card-title ">Tambah Tarif Voucher</h4>
					</div>
					<div class="card-body">
						<div class="row">
							<div class="col-md-12">
								<div class="form-group">
									<div class="form-group">
										<label class="bmd-label-floating">Pilih Mikrotik</label>
										<p class="form-control mb-0" @click="mikrotik.data.modal = true">{{mikrotik.data.mikrotikSelected}}</p>
									</div>
								</div>
							</div>
						</div>
						<div class="row" v-show="profil.data.profilBox">
							<div class="col-md-12">
								<div class="form-group">
									<div class="form-group">
										<label class="bmd-label-floating">Profil</label>
										<select class="form-control" v-model="profil.data.profilSelected">
											<option v-for="(u, index) in profil.data.List" :value="u.name">{{u.name}}</option>
										</select>
									</div>
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-md-12">
								<div class="form-group">
									<div class="form-group">
										<label class="bmd-label-floating">Nama Tarif</label>
										<input type="text" class="form-control" placeholder="Nama Tarif..." v-model="tambah.data.nama">
									</div>
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-md-12">
								<div class="form-group">
									<div class="form-group">
										<label class="bmd-label-floating">Harga Beli <br/><small class="text-secondary">(Pastikan Tarif paket tidak pakai titik/koma. Mis : 50000)</small></label>
										<input type="number" class="form-control" placeholder="Harga..." v-model="tambah.data.hargaBeli">
									</div>
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-md-12">
								<div class="form-group">
									<div class="form-group">
										<label class="bmd-label-floating">Harga Jual<br/><small class="text-secondary">(Pastikan Tarif paket tidak pakai titik/koma. Mis : 50000)</small></label>
										<input type="number" class="form-control" placeholder="Harga..." v-model="tambah.data.harga">
									</div>
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-md-12">
								<div class="form-group">
									<div class="form-group">
										<label class="bmd-label-floating">Keterangan</label>
										<input type="text" class="form-control" placeholder="Keterangan..." v-model="tambah.data.keterangan">
									</div>
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-md-12">
							<div class="form-group">
								<button class="btn btn-primary" @click="tambah.submit()">Simpan</button>
							</div>
							</div>
						</div>
						<div class="row" v-show="data.pesanBox">
							<div class="col-md-12">
								<div class="alert alert-info" role="alert">
									{{data.pesan}}
								</div>
							</div>
						</div>
					</div>
					</div>
				</div>
			</div>
		</div>
      <!-- MODAL -->
      <div class="modal" tabindex="-1" role="dialog" v-show="mikrotik.data.modal">
        <div class="overlay"></div>
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Edit Tarif Voucher</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="mikrotik.data.modal = false">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <div class="form-group">
                    	<label class="bmd-label-floating">Pilih Mikrotik</label>
						<table class="table">
							<tbody>
							<tr v-for="(u, index) in mikrotik.data.List">
								<td>{{ u.nama }}<br/><small>{{u.ip}}</small></td>
								<td>
									<button class="btn btn-small btn-primary" @click="mikrotik.data.modal = false, mikrotik.data.id = u.id, mikrotik.data.ip = u.ip, mikrotik.data.username = u.username, mikrotik.data.password = u.password, mikrotik.data.via = u.via, mikrotik.data.mikrotikSelected = u.nama, mikrotik.pilih()">Pilih</button>
								</td>
							</tr>
							<tr v-if="mikrotik.data.List == null">
								<td>Tidak ada Data </td>
							</tr>
							</tbody>
						</table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
	</div>
</template>

<script>

import Vue from 'vue'
import moment from 'moment'

import { reactive } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/Interface' 

export default {
  name: 'Beranda',
  components: { 

  }, 
  setup() {
	const data = reactive({
		pesan: '',
		pesanBox: false,
    })
	const mikrotik = {
      	data: reactive({
        	List: [],
			mikrotikSelected: 'Anda belum memilih Mikrotik',
			modal: false,
			ip: '',
			username: '',
			password: '',
			via: '',
			id: ''
      	}),
		list() {
			var datax = {
				token: 'TangTung '+sessionStorage.getItem('myToken')
			};
			
			var apiUrl = inter.mikrotikList();
			myGlobal.call(datax,apiUrl).then(x => {
				//console.log(JSON.stringify(x));
				if (x.status == true) {
					this.data.List = x.data;
				} else {
					//alert(x.pesan);
				}
			})
		},
		pilih() {
			profil.list();
			profil.data.profilBox = true;
		}
    }

	const profil = {
      	data: reactive({
			List: [],
			profilBox: false,
			profilSelected: ''
      	}),
		list() {
			var datax = {
				ip: mikrotik.data.ip,
				username: mikrotik.data.username,
				password: mikrotik.data.password,
				via: mikrotik.data.via,
			};
			
			var apiUrl = inter.mikrotikProfil();
			myGlobal.callMikrotik(datax,apiUrl).then(x => {
				//console.log(JSON.stringify(x));
				if (x.status == true) {
					this.data.List = x.data;
				} else {
					//alert(x.pesan);
				}
			})
		}
	}

	const tambah = {
      	data: reactive({
			nama: '',
			harga: '',
			hargaBeli: '',
			keterangan: ''
      	}),
		submit() {
			if (mikrotik.data.id == "") {
				data.pesan = "Anda belum memilih Mikrotik";
				data.pesanBox = true;

				return false;
			}
			if (profil.data.profilSelected == "") {
				data.pesan = "Anda belum memilih Profil (User Profile)";
				data.pesanBox = true;

				return false;
			}

			if (this.data.nama == "") {
				data.pesan = "Nama tidak boleh kosong";
				data.pesanBox = true;

				return false;
			}

			if (this.data.harga == "") {
				data.pesan = "Harga Jual tidak boleh kosong";
				data.pesanBox = true;

				return false;
			}

			if (this.data.hargaBeli == "") {
				data.pesan = "Harga Beli tidak boleh kosong";
				data.pesanBox = true;

				return false;
			}

			if (this.data.keterangan == "") {
				data.pesan = "Keterangan tidak boleh kosong";
				data.pesanBox = true;

				return false;
			}
			
			data.pesanBox = false;

			var datax = {
          		token: 'TangTung '+sessionStorage.getItem('myToken'),
				nama: this.data.nama,
				harga: this.data.harga,
				hargaBeli: this.data.hargaBeli,
				profil: profil.data.profilSelected,
				keterangan: this.data.keterangan,
				id: mikrotik.data.id
        	};
				
			var apiUrl = inter.tarifTambah();
			myGlobal.call(datax,apiUrl).then(x => {
				console.log(JSON.stringify(x));
				if (x.status == true) {
                    location.href="#/voucher"
				} else {
					//alert(x.pesan);
				}
			})
		}
    }
    return {
      data, 
      tambah,
	  mikrotik,
	  profil
    }

  },
  mounted () {
    document.title = "Tambah Tarif Voucher";

	this.mikrotik.list();
  }
}
</script>

<style scoped>
.edit-input {
	font-size: 20pt !important;
}
.file-upload {
    opacity: 1 !important;
    position: relative !important;
    z-index: 0 !important;
}
.modal {
	display: inherit;
}
</style>


// WEBPACK FOOTER //
// src/components/tarifVoucher/tambah.vue